import { render, staticRenderFns } from "./DatatableMultiSelecao.vue?vue&type=template&id=efc691e8"
import script from "./DatatableMultiSelecao.vue?vue&type=script&lang=js"
export * from "./DatatableMultiSelecao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports